import { isMemoryError } from './isMemoryError';
import { isNetworkError } from './isNetworkError';
import { isAuthError } from './isAuthError';
import isCorsIssue from './utils/isCorsIssue';
import getScriptInfoForLoadedScripts from './utils/getScriptInfoForLoadedScripts';
import type { TraceErrorObject } from 'owa-analytics-types';
import { isLocalLieError } from './isLocalLieError';
import { errorThatWillCauseAlert } from 'owa-trace';

type ErrorCategory = 'CORS' | 'NETWORK' | 'MEMORY' | 'SERVER' | 'AUTH' | 'LOCAL_LIE';

export function categorizeError(
    message: string,
    error: TraceErrorObject | undefined
): ErrorCategory | null {
    if (isCorsIssue(message)) {
        try {
            error = error || new Error('UnknownCorsIssue');
            error.additionalInfo = {
                diagnosticMessage: error.diagnosticInfo,
                loadedScripts: getScriptInfoForLoadedScripts()
                    .filter(s => s.cors === null && s.src != 'INLINE')
                    .map(
                        info =>
                            `src:${info.src} parent:${info.parentNode} base:${info.baseUri} attr:${info.attributes}\n`
                    )
                    .join(''),
            };
        } catch (e) {
            // Errors resulting from enabling useUnknownInCatchVariables
            // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'TraceErrorObject | undefined'.
            // @ts-expect-error
            errorThatWillCauseAlert('getScriptInfoForLoadedScripts error', e);
        }
        return 'CORS';
    } else if (isMemoryError(message)) {
        return 'MEMORY';
    } else if (isNetworkError(message, error)) {
        return 'NETWORK';
    } else if (isAuthError(message, error)) {
        return 'AUTH';
    } else if (error) {
        if (error.fetchErrorType) {
            return 'SERVER';
        } else if (error.networkError) {
            return 'NETWORK';
        } else if (isLocalLieError(error)) {
            return 'LOCAL_LIE';
        }
    }
    return null;
}
